<mmx-time-slot-picker-row *ngIf="timeSlot">
  <ng-container *ngIf="icon" icon>
    <mat-icon>{{ icon }}</mat-icon>
  </ng-container>

  <ng-container label>
    {{ label }}
  </ng-container>

  <ng-container timeslot>
    {{ formattedTimeSlot }}
  </ng-container>

  <ng-container actions>
    <button
      mat-fab
      color="primary"
      [disabled]="disabled"
      (click)="add.emit(timeSlot)"
    >
      <mat-icon>add</mat-icon>
    </button>
  </ng-container>
</mmx-time-slot-picker-row>
